import { render, staticRenderFns } from "./graficosInvolucrados.vue?vue&type=template&id=1d982c00&"
import script from "./graficosInvolucrados.vue?vue&type=script&lang=js&"
export * from "./graficosInvolucrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports